import React, { useRef, useState } from 'react';
import moment from 'moment';
import { useEffect } from 'react';
import { GetDifferenceReport } from './function';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectPrefix,
  selectStationId,
  selectStationName,
  selectUserType,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setStationID,
  setStationName,
  setreportsFromDate,
  setreportsTodate,
} from '../utility/Redux/profile';
import { selectToken } from '../utility/Redux/security';
import { DeffrenceReportColumns } from './columns';
import GeniusReportsDate from '../utility/component/reportDate';
import {
  setAlertWithTitle,
  setListStationMasterModalStatus,
} from '../utility/Redux/modal';
import ModListStationMaster from '../utility/component/modals/modListStationMaster';
import GeniusTableReports from '../utility/component/geniusComponents/geniusTableforReports';
import ReactToPrint from 'react-to-print';
import IsLocalData from '../utility/functions/ceckLocalData';
import ReportDataTable from '../utility/component/datagrid/ReportDataTable';
import { FormatNumber2 } from '../utility/component/tools';

const DiffrentReport = () => {
  const fromDate = useSelector(selectreportFromDate);
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const toDate = useSelector(selectreportToDate);
  const [toDateFocus, setToDateFocus] = useState(false);
  const ReduxStation_id = useSelector(selectStationId);
  const ReduxStationName = useSelector(selectStationName);
  const userType = useSelector(selectUserType);
  const [list, setList] = useState([]);
  const printRef = useRef();
  const prefix = useSelector(selectPrefix);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const windowWidth = useSelector(selectWidth);

  const okButton = () => {
    if (ReduxStation_id) {
      GetDifferenceReport(
        prefix,
        dispatch,
        token,
        setList,
        fromDate,
        toDate,
        ReduxStation_id,
        ReduxStationName
      );
    } else {
      dispatch(
        setAlertWithTitle({
          title: 'Alert',
          msg: 'Please select station first',
        })
      );
    }
  };

  const columns = DeffrenceReportColumns(windowWidth);
  const tableColumns = columns.map((column) => {
    const amountFields = ['BILL_CASH_AMOUNT', 'BTC_AMOUNT', 'CASH', 'DEBIT'];

    if (amountFields.includes(column.field)) {
      return { ...column, width: Math.max(Number(column.width) || 0, 140) };
    }

    return column;
  });

  const totalBillAmount = list.reduce(
    (total, row) => Number(total) + Number(row.BILL_CASH_AMOUNT),
    0
  );
  const totalBTCAmount = list.reduce(
    (total, row) => Number(total) + Number(row.BTC_AMOUNT),
    0
  );
  const totalCash = list.reduce(
    (total, row) => Number(total) + Number(row.CASH),
    0
  );
  const totalDebit = list.reduce(
    (total, row) => Number(total) + Number(row.DEBIT),
    0
  );

  useEffect(() => {
    const elseFunc = () => {
      if (userType !== 'USER') {
        dispatch(setStationID(''));
        dispatch(setStationName(''));
      }
    };

    const callback = (details, data) => {
      setList(data);
      dispatch(
        setreportsFromDate(moment(details[0].from_date).format('YYYY-MM-DD'))
      );
      dispatch(
        setreportsTodate(moment(details[0].to_date).format('YYYY-MM-DD'))
      );
      dispatch(setStationID(details[0].SID));
      dispatch(setStationName(details[0].SNAME));
    };

    IsLocalData('Difference_report', callback, elseFunc);
  }, []);

  const isMismatchRow = (row) => {
    if (row.BILL_CASH_AMOUNT > 0 && row.CASH > 0) {
      return Number(row.BILL_CASH_AMOUNT) !== Number(row.CASH);
    }

    if (row.BTC_AMOUNT > 0 && row.DEBIT > 0) {
      return Number(row.BTC_AMOUNT) !== Number(row.DEBIT);
    }

    return false;
  };

  const footerValue = (column) => {
    if (column.field === 'SID') return 'TOTAL';
    if (column.field === 'BILL_CASH_AMOUNT') return FormatNumber2(totalBillAmount);
    if (column.field === 'BTC_AMOUNT') return FormatNumber2(totalBTCAmount);
    if (column.field === 'CASH') return FormatNumber2(totalCash);
    if (column.field === 'DEBIT') return FormatNumber2(totalDebit);
    return '';
  };

  return (
    <div className="h-full w-full p-2 text-sm">
      {window.innerWidth <= 500 ? (
        <>
          <div
            style={{
              border: '1px solid #b5b3b3',
            }}
            className="p-1  py-3 rounded-t-sm  flex items-center "
          >
            <div className="px-1 ">From</div>

            <GeniusReportsDate
              date={fromDate}
              onChange={(e) => {
                dispatch(setreportsFromDate(moment(e).format('YYYY-MM-DD')));
                setFromDateFocus(false);
              }}
              dateFocus={fromDateFocus}
              SetDateFocus={setFromDateFocus}
            />
            <div className="px-1 pl-2 ">To</div>
            <GeniusReportsDate
              date={toDate}
              onChange={(e) => {
                dispatch(setreportsTodate(moment(e).format('YYYY-MM-DD')));
                setToDateFocus(false);
              }}
              dateFocus={toDateFocus}
              SetDateFocus={setToDateFocus}
            />
          </div>
          <div style={{ border: '1px solid #b5b3b3', borderTop: '0px' }}>
            {userType === 'USER' ? null : (
              <div className="flex  text-[#4B4545] p-2  ">
                <div
                  onClick={() => {
                    if (userType === 'MANAGER' ||userType === 'STORE' ) {
                      dispatch(setListStationMasterModalStatus(true));
                    }
                  }}
                  style={{ fontSize: 13 }}
                  className=" flex whitespace-normal  justify-center items-center hover:cursor-pointer "
                >
                  <div className="flex items-center ">
                    <div>
                      <i
                        className="bi bi-search"
                        style={{ color: '#f44336', fontSize: 15 }}
                      ></i>
                    </div>

                    <span
                      style={{ fontSize: 12, fontWeight: 600 }}
                      className=" text-[#5c5b5b] pl-2 whitespace-nowrap  items-center"
                    >
                      Station ID
                    </span>
                  </div>
                  <div
                    style={{
                      border: '1px dotted #a6a2a2 ',
                      borderRadius: '3px',
                    }}
                    className="flex text-[#a6a2a2]  pl-2 ml-2  "
                  >
                    <input
                      size={'small'}
                      placeholder="All"
                      value={ReduxStation_id ? ReduxStation_id : 'All'}
                      style={{
                        // width: '20%',
                        fontSize: 12,
                        paddingTop: '2px',
                        paddingBottom: '2px',
                        backgroundColor: 'transparent',
                      }}
                      readOnly
                      className=" outline-0 w-6"
                    />

                    <div
                      style={{
                        borderLeft: '1px dotted #a6a2a2 ',
                      }}
                      className="px-2 p-1 w-48 whitespace-nowrap print:hidden"
                    >
                      {ReduxStationName ? `${ReduxStationName}` : null}
                    </div>
                  </div>
                  <div>
                    <button
                      onClick={okButton}
                      className="flex items-center rounded-sm ml-2"
                      style={{
                        backgroundColor: '#c1c1c1',
                        paddingLeft: 30,
                        paddingRight: 30,
                        paddingTop: 4,
                        paddingBottom: 4,
                        color: 'black',
                      }}
                    >
                      <div className="flex items-center text-sm">Ok</div>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      ) : (
        <div
          style={{
            border: '1px solid #b5b3b3',
            width: '100%',
          }}
          className=" pl-2 rounded-sm flex flex-wrap items-center "
        >
          <div className=" rounded-sm  flex items-center ">
            <div className="px-1 text-[13px]">From</div>

            <GeniusReportsDate
              date={fromDate}
              onChange={(e) => {
                dispatch(setreportsFromDate(moment(e).format('YYYY-MM-DD')));
                setFromDateFocus(false);
              }}
              dateFocus={fromDateFocus}
              SetDateFocus={setFromDateFocus}
            />
            <div className="mx-4 ">To</div>
            <GeniusReportsDate
              date={toDate}
              onChange={(e) => {
                dispatch(setreportsTodate(moment(e).format('YYYY-MM-DD')));
                setToDateFocus(false);
              }}
              dateFocus={toDateFocus}
              SetDateFocus={setToDateFocus}
            />
          </div>

          <div
            style={{
              borderLeft: '1px solid #b5b3b3',
            }}
            className="flex px-4  ml-5 text-[#4B4545] p-3  "
          >
            <div
              style={{ fontSize: 13 }}
              className=" flex whitespace-normal  justify-center items-center  "
            >
              <div className="flex items-center ">
                <div
                  onClick={() => {
                    if (userType === 'MANAGER' || userType === 'ADMIN'||userType ==="STORE") {
                      dispatch(setListStationMasterModalStatus(true));
                    }
                  }}
                  className="hover:cursor-pointer"
                >
                  <i
                    className="bi bi-search"
                    style={{ color: '#f44336', fontSize: 15 }}
                  ></i>
                </div>

                <span
                  style={{ fontSize: 12, fontWeight: 600 }}
                  className=" text-[#5c5b5b] pl-2 whitespace-nowrap  items-center"
                >
                  {' '}
                  Station ID{' '}
                </span>
              </div>

              <div
                style={{
                  border: '1px dotted #a6a2a2 ',
                  borderRadius: '3px',
                }}
                className="flex text-[#a6a2a2]  pl-2 ml-2  "
              >
                <input
                  size={'small'}
                  placeholder="All"
                  value={ReduxStation_id ? ReduxStation_id : 'All'}
                  style={{
                    fontSize: 12,
                    paddingTop: '2px',
                    paddingBottom: '2px',
                    backgroundColor: 'transparent',
                  }}
                  readOnly
                  className=" outline-0 w-12 "
                />

                <div
                  style={{
                    borderLeft: '1px dotted #a6a2a2 ',
                  }}
                  className="px-2 p-1 whitespace-nowrap print:hidden"
                >
                  {ReduxStationName ? `${ReduxStationName}` : null}
                </div>
              </div>
              <div className="flex">
                <button
                  onClick={okButton}
                  className="flex items-center rounded-sm ml-2"
                  style={{
                    backgroundColor: '#c1c1c1',
                    paddingLeft: 30,
                    paddingRight: 30,
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: 'black',
                  }}
                >
                  <div className="flex items-center text-sm">Ok</div>
                </button>
                {list[0] && (
                  <ReactToPrint
                    trigger={() => {
                      return (
                        <button
                          style={{
                            width: 'auto',
                            borderRadius: '7px',
                            height: 'auto',
                            paddingLeft: 30,
                            paddingRight: 30,
                            paddingTop: 4,
                            paddingBottom: 4,
                            marginLeft: 7,
                            backgroundColor: '#bad4f9',
                            color: 'black',
                          }}
                        >
                          <div className="text-sm">Print</div>
                        </button>
                      );
                    }}
                    content={() => printRef.current}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div
        style={
          windowWidth > 768
            ? {
                height: `calc(100% - 220px)`,
                width: '100%',
              }
            : {
                height: `calc(100% - 220px)`,
              }
        }
        className="mt-2 w-full "
      >
        <ReportDataTable
          columns={tableColumns}
          rows={list}
          getRowKey={(row, index) => row.INVNO || `${row.DATE}-${row.SID}-${index}`}
          getRowClassName={(row) =>
            isMismatchRow(row) ? '!bg-red-50 text-red-700 font-semibold' : ''
          }
          footerValue={footerValue}
          emptyTitle="No records found"
          emptyDescription="Select a station and run the difference report."
          maxHeight="100%"
        />
      </div>

      <div
        style={
          windowWidth > 768
            ? {
                border: '0px solid #b5b3b3',
                width: '100%',
              }
            : {
                border: '0px solid #b5b3b3',
              }
        }
        className="mt-2 flex justify-end"
      >
        <div
          ref={printRef}
          style={{ width: '100%', display: 'block', visibility: 'hidden' }}
        >
          <GeniusTableReports
            stationId={ReduxStation_id}
            date={fromDate}
            date1={toDate}
            columns={columns}
            data={list}
            headerWidth={'80px'}
            title={'Difference Report'}
          />
        </div>
      </div>

      <ModListStationMaster
        onRowClick={(p) => {
          setList([]);
          dispatch(setStationID(p.row.CODE));
          dispatch(setStationName(p.row.STATION_NAME));
          dispatch(setListStationMasterModalStatus(false));
        }}
      />
    </div>
  );
};

export default DiffrentReport;
